
























































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import RequiredMarkComponent from "@/components/common/parts/RequiredMarkComponent.vue";
import FormBoxComponent from "@/components/common/form/FormBoxComponent.vue";
import FormRowComponent from "@/components/common/form/FormRowComponent.vue";
import RadioComponent from "@/components/common/parts/RadioComponent.vue";
import CheckboxComponent from "@/components/common/parts/CheckboxComponent.vue";
import IconCheckboxComponent from "@/components/pages/reports/IconCheckboxComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import DatepickerComponent from "@/components/packages/datepicker/DatepickerComponent.vue";
import TimepickerComponent from "@/components/packages/timepicker/TimepickerComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import MultiMailComponent from "@/components/common/parts/MultiMailComponent.vue";
import ReportSaveDialogComponent from "@/components/pages/reports/ReportSaveDialogComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { Moment } from "@/typescript/lib/common/moment";
import { getReportCategories } from "@/typescript/pages/reports/functions";
import { storeMenus } from "@/config/store_menus";
import { getStoreSensorsApi } from "@/typescript/api_client/emesh_api/stores/store_sensors_api";
import { getEquipmentsApi } from "@/typescript/api_client/emesh_api/equipments/equipments_api";
import {
  postStoreReportApi,
  getStoreReportApi
} from "@/typescript/api_client/emesh_api/reports/store_report_api";
import { getEquipmentIcon } from "@/typescript/lib/common/get_equipment_icon";
import {
  ReportCategory,
  ReportCategoryProperty,
  ReportType,
  MarginRadioType
} from "@/typescript/pages/reports/types";
import {
  GetStoreReportResponse,
  PostStoreReportRequest
} from "@/typescript/api_client/emesh_api/reports/types";
import { GetStoreSensorsResponse } from "@/typescript/api_client/emesh_api/stores/types";

import { getRoutePath } from "@/router/routes";
import { DisplayTime } from "@/typescript/packages/timepicker/types";

export {
  DisplayTime,
  ReportCategory,
  ReportCategoryProperty,
  ReportType,
  MarginRadioType,
  GetStoreSensorsResponse,
  PostStoreReportRequest,
  GetStoreReportResponse
};
const format: string = "YYYY/MM/DD";
const today = new Moment(format).getFormatDate();

// 非表示センサを表示するためのAPIパラメータ値
const SHOW_HIDDEN_SENSOR: number = 1;

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    RequiredMarkComponent,
    FormBoxComponent,
    FormRowComponent,
    RadioComponent,
    InputTextComponent,
    IconCheckboxComponent,
    CheckboxComponent,
    DatepickerComponent,
    TimepickerComponent,
    ButtonComponent,
    MultiMailComponent,
    ReportSaveDialogComponent,
    ConfirmDialogComponent,
    SelectComponent,
    FooterComponent
  }
})
export default class ReportsCreatePage extends Vue {
  $refs!: {
    from_datepicker: Vue;
    to_datepicker: Vue;
  };

  selectAll: boolean = false;
  reportName: { [s: string]: any } = { value: "", errors: [] };
  fileName: { [s: string]: any } = { value: "", errors: [] };
  sensorSelect: { [s: string]: any } = { errors: [] };
  fromDate: { [s: string]: any } = { value: today, errors: [] };
  toDate: { [s: string]: any } = { value: today, errors: [] };
  mails: { [s: string]: any } = { value: [""], errors: [] };
  timeMargin: { [s: string]: any } = { value: "10", errors: [] };
  selectedTimes: DisplayTime[] = [];
  timepickerValue: DisplayTime = { HH: "00", mm: "00" };
  fromReportCategoryTime: DisplayTime = { HH: "00", mm: "00" };
  toReportCategoryTime: DisplayTime = { HH: "23", mm: "50" };
  selectedReportCategory: ReportCategoryProperty = "month";
  selectedReportType: ReportType = "successively";
  selectedMarginRadio: MarginRadioType = "every_10_min";
  exportFormat: string = "pdf";
  commentFlag: string = "0";
  summaryFlag: string = "0";
  recieveMail: boolean = true;
  reportAttachment: boolean = true;
  hasError: boolean = false;
  errorMessages: { [s: string]: string } = {
    required_select: "選択してください",
    required_input: "入力してください",
    mistake_input: "指定が違います",
    format: "フォーマットが違います",
    number: "数字を入力してください",
    range: "範囲が違います",
    ten_mints: "10単位で指定してください"
  };
  isDialogVisible: boolean = false;
  dialogLinkPath: string = "";
  isConfirmDialogOpen: boolean = false;

  sensors: { [s: string]: any }[] = [];
  reportCount: number = 0;

  created() {
    this.$store.commit("setActiveId", {
      //activeId: storeMenus().find(m => m.pageName === "SensorsShowPage")?.id
      activeId: storeMenus().find(m => m.pageName === "ReportsPage")?.id
    });
    this.setSensors();
    this.setReportCount();
    this.dialogLinkPath = getRoutePath("ReportsPage", {
      store_id: this.$route.params.store_id
    });
  }

  get outputFormatValue() {
    return {
      pdf: 1,
      csv: 2
    };
  }

  get reportTypes() {
    return {
      successively: 0, // 逐次レポート
      regular: 1 // 定期レポート
    };
  }

  get reportCagtegories() {
    return {
      month: 1,
      week: 2,
      day: 3,
      free: 4
    };
  }

  get reportCategory(): ReportCategory {
    const reportCategory: ReportCategory = getReportCategories(
      this.fromDate.value,
      this.toDate.value
    )[this.selectedReportCategory];
    this.fromDate.value = reportCategory.fromDate;
    this.toDate.value = reportCategory.toDate;
    return reportCategory;
  }

  get showRegularWarning(): boolean {
    if (this.selectedReportType !== "regular") return false;
    return this.reportCount >= 10;
  }

  get params(): PostStoreReportRequest {
    let equipmentIds: string[] = [];
    this.selectedSensors.map(sensor => {
      if (sensor.selected) {
        equipmentIds.push(sensor.equipmentId);
      }
    });
    return {
      store_id: this.$route.params.store_id,
      setting_no: null, // 新規追加はnull
      setting_name: this.settingName,
      file_name: this.fileName.value,
      report_type: this.reportCagtegories[this.selectedReportCategory],
      regular_report: this.reportTypes[this.selectedReportType],
      data_interval: this.dataInterval,
      manual_data_interval: this.manualDataInterval,
      start_time: this.startTime,
      end_time: this.endTime,
      output_format: this.outputFormatValue[this.exportFormat],
      mail_flg: this.mailFlag,
      option1: this.commentFlag,
      option2: this.summaryFlag,
      option3: "0",
      option4: "0",
      option5: "0",
      equipment_ids: equipmentIds,
      mail_addresses: this.mailAddresses.filter(mail => mail.length > 0),
      attachment_flg: this.attachmentFlag
    };
  }

  setSensors() {
    this.getSensorsInfo().then(resp => {
      this.sensors = resp;
    });
  }

  async getSensorsInfo() {
    const storeSensors = await getStoreSensorsApi(
      this.$route.params.store_id,
      SHOW_HIDDEN_SENSOR
    ).then((resp: GetStoreSensorsResponse) => {
      return resp;
    });

    return Promise.all(
      storeSensors.sensors.map(async sensor => {
        const equipment = await getEquipmentsApi(sensor.equipment_id);
        return {
          equipmentId: sensor.equipment_id,
          equipmentName: sensor.equipment_name,
          iconKind: equipment.icon_kind,
          selected: false,
          dispFlg: sensor.disp_flg
        };
      })
    );
  }

  get settingName() {
    return this.selectedReportType === "regular"
      ? this.reportName.value
      : "逐次レポート";
  }

  get mailFlag() {
    return this.recieveMail ? 1 : 0;
  }

  get attachmentFlag() {
    return this.selectedReportCategory === "month" &&
      this.recieveMail &&
      this.reportAttachment
      ? 1
      : 0;
  }

  get isShowReportAttachment() {
    return this.selectedReportCategory === "month" && this.recieveMail;
  }

  get startTime() {
    const date = this.fromDate.value.replace(/\//g, "");
    const time = this.fromReportCategoryTime;
    return `${date}${time.HH}${time.mm}00`;
  }

  get endTime() {
    const date = this.toDate.value.replace(/\//g, "");
    const time = this.toReportCategoryTime;
    return `${date}${time.HH}${time.mm}00`;
  }

  get selectedSensors() {
    return [...this.sensors].filter(sensor => sensor.selected);
  }

  get mailAddresses() {
    return this.mails.value;
  }

  get dataInterval() {
    if (this.selectedMarginRadio === "time_target") return null;
    if (this.selectedMarginRadio === "every_10_min") return 10;
    return parseInt(this.timeMargin.value, 10);
  }

  get manualDataInterval() {
    if (this.selectedMarginRadio !== "time_target") return [];
    return [...this.selectedTimes].map(time => `${time.HH}:${time.mm}`);
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    this.$router.push(
      getRoutePath("ReportsPage", {
        store_id: this.$route.params.store_id
      })
    );
  }

  addInput(value: string) {
    this.mails.value.push(value);
  }

  getCategoryImage(iconNum: number, status: "on" | "off"): string {
    return getEquipmentIcon(iconNum, status);
  }

  updateValue(key: string, value: any) {
    this[key] = value;
  }
  updateObjectValue(key: string, value: any) {
    this[key].value = value;
  }
  updateFlag(key: string, value: boolean) {
    this[key] = value ? "1" : "0";
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  openCalendar(calendarRefName: string) {
    this.$refs[calendarRefName].showCalendar();
  }

  addTime(value: DisplayTime) {
    const displayTime: string = `${value.HH}${value.mm}`;
    if (this.selectedTimes.some(dt => `${dt.HH}${dt.mm}` === displayTime))
      return;
    this.selectedTimes.push(value);
  }

  deleteSelectedTime(value: DisplayTime) {
    const displayTime: string = `${value.HH}${value.mm}`;
    this.selectedTimes = this.selectedTimes.filter(
      dt => `${dt.HH}${dt.mm}` !== displayTime
    );
  }

  updateDate(date: string) {
    if (this.selectedReportCategory === "month") {
      this.toDate.value = new Moment(format, date, format).getEndOf("month");
    }

    if (this.selectedReportCategory === "week") {
      this.fromDate.value = new Moment(format, date, format).getStartOf("week");
      this.toDate.value = new Moment(format, date, format).getEndOf("week");
    }

    if (this.selectedReportCategory === "day") {
      this.toDate.value = new Moment(format, date, format).getFormatDate();
    }
  }

  getRegularReportCategory(regularReportCategory: string): string {
    if (regularReportCategory === "month") {
      return "前月1日の深夜0:00から、前月末日23:50までの期間レポートを定期作成します";
    }

    if (regularReportCategory === "week") {
      return "前週日曜日の深夜0:00から、前週末土曜日23:50までの期間レポートを定期作成します";
    }

    if (regularReportCategory === "day") {
      return "前日の深夜0:00から、同日23:50までのレポートを毎日作成します";
    }

    return "";
  }

  handleChangeMail(value: Array<string>) {
    this.mails.value = value;
  }

  setSelectedTime(value: DisplayTime) {
    this.timepickerValue = value;
  }

  setReportCategory(reportCategory: ReportCategoryProperty) {
    this.selectedReportCategory = reportCategory;
    this.updateDate(this.fromDate.value);
  }

  setFromDate(date: string) {
    this.fromDate.value = date;
    this.updateDate(date);
  }

  setToDate(date: string) {
    this.toDate.value = date;
  }

  setReportType(reportType: ReportType) {
    this.selectedReportType = reportType;
  }

  setMarginRadio(marginRadio: MarginRadioType) {
    this.selectedMarginRadio = marginRadio;
  }

  selectSensor(id: string, value: boolean) {
    let sensors = [...this.sensors];
    sensors.map(sensor => {
      if (sensor.equipmentId === id) {
        sensor.selected = value;
      }
    });
    this.sensors = sensors;
  }

  selectAllChange(value: boolean) {
    let sensors = [...this.sensors];
    sensors.map(sensor => (sensor.selected = value));
    this.sensors = sensors;
    this.selectAll = value;
  }

  submit() {
    this.resetError();
    this.validateForm();
    if (this.hasError) return;

    this.save();
  }

  save() {
    postStoreReportApi(this.params).then(() => {
      this.isDialogVisible = true;
    });
  }

  //バリデーション関数
  isErrorForm(form) {
    return this[form].errors.length > 0;
  }

  getErrorMessages(form) {
    return this[form].errors;
  }

  validateForm() {
    if (this.selectedReportType == "regular" && this.reportName.value === "")
      this.addError("reportName", "required_input");
    if (this.selectedSensors.length == 0) {
      this.addError("sensorSelect", "required_select");
    }
    if (this.fileName.value.length == 0) {
      this.addError("fileName", "required_input");
    }
    if (
      this.selectedReportType === "successively" &&
      !Moment.isBefore(
        `${this.fromDate.value} 00:00`,
        `${this.toDate.value} 23:50`,
        "YYYY/MM/DD HH:mm"
      )
    ) {
      this.addError("fromDate", "mistake_input");
    }
    if (this.recieveMail && !this.mails.value.some(value => value != "")) {
      this.addError("mails", "required_input");
    }
    if (this.selectedMarginRadio === "time_margin_target") {
      this.validateTimeMargin();
    }
    if (this.recieveMail) {
      this.validateMail();
    }
  }

  validateTimeMargin() {
    if (this.timeMargin.value.length === 0) {
      this.addError("timeMargin", "required_input");
    }
    if (/[^0-9]/.test(this.timeMargin.value)) {
      this.addError("timeMargin", "number");
    }
    const number = parseInt(this.timeMargin.value, 10);
    if (number < 10 || number > 720) {
      this.addError("timeMargin", "range");
    }
    if (number % 10 !== 0) {
      this.addError("timeMargin", "ten_mints");
    }
  }

  validateMail() {
    [...this.mails.value].map(mail => {
      if (!/.+@.+\..+/.test(mail)) {
        this.addError("mails", "format");
      }
    });
  }

  setReportCount() {
    getStoreReportApi(this.$route.params.store_id).then(
      (reports: GetStoreReportResponse) => {
        this.reportCount = reports.length;
      }
    );
  }

  addError(form, error) {
    let errors = [...this[form].errors];
    errors.push(this.errorMessages[error]);
    this[form].errors = errors;
    this.hasError = true;
  }

  resetError() {
    this.hasError = false;
    const formNames = [
      "reportName",
      "fileName",
      "sensorSelect",
      "fromDate",
      "mails",
      "timeMargin"
    ];
    formNames.forEach(name => {
      this[name].errors = [];
    });
  }
}
